/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DimensionContributionLine
 */
export interface DimensionContributionLine {
    /**
     * 
     * @type {string}
     * @memberof DimensionContributionLine
     */
    dimensionKey?: string;
    /**
     * 
     * @type {string}
     * @memberof DimensionContributionLine
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof DimensionContributionLine
     */
    primaryCsfFunction?: string;
    /**
     * 
     * @type {number}
     * @memberof DimensionContributionLine
     */
    effectiveWeight?: number;
    /**
     * 
     * @type {number}
     * @memberof DimensionContributionLine
     */
    baselineScore?: number;
    /**
     * 
     * @type {number}
     * @memberof DimensionContributionLine
     */
    score?: number;
    /**
     * 
     * @type {number}
     * @memberof DimensionContributionLine
     */
    targetScore?: number;
    /**
     * 
     * @type {number}
     * @memberof DimensionContributionLine
     */
    weightedScore?: number;
    /**
     * 
     * @type {number}
     * @memberof DimensionContributionLine
     */
    designedScore?: number;
    /**
     * 
     * @type {number}
     * @memberof DimensionContributionLine
     */
    operationalScore?: number;
    /**
     * 
     * @type {number}
     * @memberof DimensionContributionLine
     */
    validatedScore?: number;
    /**
     * 
     * @type {string}
     * @memberof DimensionContributionLine
     */
    operationalStatus?: string;
    /**
     * 
     * @type {number}
     * @memberof DimensionContributionLine
     */
    operationalGap?: number;
    /**
     * 
     * @type {string}
     * @memberof DimensionContributionLine
     */
    dataSource?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DimensionContributionLine
     */
    validated?: boolean;
}

/**
 * Check if a given object implements the DimensionContributionLine interface.
 */
export function instanceOfDimensionContributionLine(value: object): value is DimensionContributionLine {
    return true;
}

export function DimensionContributionLineFromJSON(json: any): DimensionContributionLine {
    return DimensionContributionLineFromJSONTyped(json, false);
}

export function DimensionContributionLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): DimensionContributionLine {
    if (json == null) {
        return json;
    }
    return {
        
        'dimensionKey': json['dimensionKey'] == null ? undefined : json['dimensionKey'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'primaryCsfFunction': json['primaryCsfFunction'] == null ? undefined : json['primaryCsfFunction'],
        'effectiveWeight': json['effectiveWeight'] == null ? undefined : json['effectiveWeight'],
        'baselineScore': json['baselineScore'] == null ? undefined : json['baselineScore'],
        'score': json['score'] == null ? undefined : json['score'],
        'targetScore': json['targetScore'] == null ? undefined : json['targetScore'],
        'weightedScore': json['weightedScore'] == null ? undefined : json['weightedScore'],
        'designedScore': json['designedScore'] == null ? undefined : json['designedScore'],
        'operationalScore': json['operationalScore'] == null ? undefined : json['operationalScore'],
        'validatedScore': json['validatedScore'] == null ? undefined : json['validatedScore'],
        'operationalStatus': json['operationalStatus'] == null ? undefined : json['operationalStatus'],
        'operationalGap': json['operationalGap'] == null ? undefined : json['operationalGap'],
        'dataSource': json['dataSource'] == null ? undefined : json['dataSource'],
        'validated': json['validated'] == null ? undefined : json['validated'],
    };
}

export function DimensionContributionLineToJSON(json: any): DimensionContributionLine {
    return DimensionContributionLineToJSONTyped(json, false);
}

export function DimensionContributionLineToJSONTyped(value?: DimensionContributionLine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dimensionKey': value['dimensionKey'],
        'displayName': value['displayName'],
        'primaryCsfFunction': value['primaryCsfFunction'],
        'effectiveWeight': value['effectiveWeight'],
        'baselineScore': value['baselineScore'],
        'score': value['score'],
        'targetScore': value['targetScore'],
        'weightedScore': value['weightedScore'],
        'designedScore': value['designedScore'],
        'operationalScore': value['operationalScore'],
        'validatedScore': value['validatedScore'],
        'operationalStatus': value['operationalStatus'],
        'operationalGap': value['operationalGap'],
        'dataSource': value['dataSource'],
        'validated': value['validated'],
    };
}

